module.exports = __webpack_public_path__ + "img/still (37).4f60fc6c.jpg";